<template>
    <v-container fluid fill-height class="loginOverlay">
        <v-layout flex align-center justify-center>
            <v-flex xs12 sm4 elevation-6>
                <v-toolbar class="primary">
                    <v-avatar size="30px">
                        <img :src="require('./../assets/icon.png')" alt="SDeveloper" />
                    </v-avatar>
                    <v-toolbar-title class="white--text">
                        <h4>SDeveloper.io</h4>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card>
                    <v-card-text class="pt-4">
                        <div>
                            <v-form v-model="valid" ref="form">
                                <v-text-field label="Digite o usuário" v-model="input.email" :rules="emailRules" required />
                                <v-text-field
                                    label="Digite a senha"
                                    v-model="input.password"
                                    min="8"
                                    :rules="passwordRules"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                    :type="show1 ? 'text' : 'password'"
                                    @click:append="show1 = !show1"
                                    counter
                                    required
                                    @keyup.enter="login()"
                                />
                                <v-switch v-model="input.keep" inset label="Manter logado" />
                                <v-layout justify-space-between>
                                    <v-btn :loading="loading" :disabled="loading" v-on:click="login()" :class="{ 'blue darken-4 white--text': valid, disabled: !valid }"
                                        >Login</v-btn
                                    >
                                    <router-link :to="{ name: 'recovery' }" tag="v-btn">
                                        <v-btn text small>Esqueci a senha</v-btn>
                                    </router-link>
                                </v-layout>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import auth from "../helpers/auth";
import api from "../helpers/api";

export default {
    name: "Login",
    data() {
        return {
            auth,
            api,
            loading: false,
            valid: false,
            show1: false,
            passwordRules: [(v) => !!v || "Senha é obrigatória"],
            emailRules: [(v) => !!v || "Usuário é obrigatório", (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail inválido."],
            input: {
                email: "",
                password: "",
                keep: true,
            },
        };
    },
    methods: {
        login() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.api.post(
                    this.$http,
                    "auth",
                    this.input,
                    (res) => {
                        this.auth.login(this.input, res);
                        //this.loading = false;
                    },
                    (err) => {
                        this.$root.$emit("msgError", err.body.message ? err.body.message : "Usuário e/ou Senha incorretos.");
                        this.loading = false;
                    }
                );
            } else {
                this.$root.$emit("msgError", "Digite usuário e senha.");
            }
        },
    },
};
</script>